// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + (chunkId === 804 ? "shared" : chunkId) + "." + __webpack_require__.h() + ".js";
};